'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
var parseDataAttributes = require('./parseDataAttributes-81c8dbee.js');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');
var theme_emotionUtils = require('./theme/emotionUtils.js');
var react = require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
// TODO: add LayoutContext and make this configurable value. Same for base=12|16
var GAP_DEFAULT = 16;
var Container = styled__default["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    --base: 12;\n    --gap: ", "px;\n    --containerWidth: ", ";\n\n    margin: auto;\n    max-width: 100%;\n    width: var(--containerWidth);\n"])), GAP_DEFAULT, function (_ref) {
  var containerWidth = _ref.containerWidth;
  return containerWidth;
});
var Row$1 = styled__default["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n\n    /* gap variable is taken from Container */\n    gap: var(--gap);\n"])));
var setFluidWidth = function setFluidWidth(breakpoint) {
  return breakpoint === 'fluid' && theme_emotionUtils.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral__default["default"](["\n        flex-grow: 1;\n    "])));
};
var Col = styled__default["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral__default["default"](["\n    --totalGaps: calc(var(--gap) * (var(--base) - 1));\n    --includedGaps: calc(var(--gap) * (var(--span) - 1));\n    --singleWidth: calc((var(--containerWidth) - var(--totalGaps)) / var(--base));\n    --totalWidth: calc(var(--singleWidth) * var(--span) + var(--includedGaps));\n    --offsetWidth: calc(var(--singleWidth) * var(--offset) + var(--gap) * var(--offset));\n\n    flex: var(--span);\n    margin-left: var(--offsetWidth);\n    max-width: var(--totalWidth);\n\n    ", " {\n        --offset: ", ";\n        --span: ", ";\n\n        ", ";\n    }\n\n    ", " {\n        --offset: ", ";\n        --span: ", ";\n\n        ", "\n    }\n\n    ", " {\n        --offset: ", ";\n        --span: ", ";\n        ", "\n    }\n\n    ", " {\n        --offset: ", ";\n        --span: ", ";\n        ", "\n    }\n\n    ", " {\n        --offset: ", ";\n        --span: ", ";\n        ", "\n    }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "@media ".concat(theme.mediaQueries.xsMin);
}, function (_ref3) {
  var offsetXS = _ref3.offsetXS;
  return offsetXS;
}, function (_ref4) {
  var _ref4$xs = _ref4.xs,
    xs = _ref4$xs === void 0 ? 1 : _ref4$xs;
  return xs;
}, function (_ref5) {
  var xs = _ref5.xs;
  return setFluidWidth(xs);
}, function (_ref6) {
  var theme = _ref6.theme;
  return "@media ".concat(theme.mediaQueries.smMin);
}, function (_ref7) {
  var offsetSM = _ref7.offsetSM;
  return offsetSM;
}, function (_ref8) {
  var sm = _ref8.sm;
  return sm;
}, function (_ref9) {
  var sm = _ref9.sm;
  return setFluidWidth(sm);
}, function (_ref10) {
  var theme = _ref10.theme;
  return "@media ".concat(theme.mediaQueries.mdMin);
}, function (_ref11) {
  var offsetMD = _ref11.offsetMD;
  return offsetMD;
}, function (_ref12) {
  var md = _ref12.md;
  return md;
}, function (_ref13) {
  var sm = _ref13.sm;
  return setFluidWidth(sm);
}, function (_ref14) {
  var theme = _ref14.theme;
  return "@media ".concat(theme.mediaQueries.lgMin);
}, function (_ref15) {
  var offsetLG = _ref15.offsetLG;
  return offsetLG;
}, function (_ref16) {
  var lg = _ref16.lg;
  return lg;
}, function (_ref17) {
  var sm = _ref17.sm;
  return setFluidWidth(sm);
}, function (_ref18) {
  var theme = _ref18.theme;
  return "@media ".concat(theme.mediaQueries.xlMin);
}, function (_ref19) {
  var offsetXL = _ref19.offsetXL;
  return offsetXL;
}, function (_ref20) {
  var xl = _ref20.xl;
  return xl;
}, function (_ref21) {
  var sm = _ref21.sm;
  return setFluidWidth(sm);
});
styled__default["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral__default["default"](["\n    align-items: center;\n    background: ", ";\n    border-radius: 4px;\n    color: ", ";\n    display: flex;\n    flex-direction: column;\n    height: 64px;\n    justify-content: center;\n    width: 100%;\n"])), function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors['background-brand-primary'];
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors['text-global-inverse'];
});

var _excluded = ["className", "children", "as", "dataAttributes", "innerRef"];
var Row = function Row(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes,
    innerRef = _ref.innerRef,
    nativeProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  return react.jsx(Row$1, _extends__default["default"]({}, nativeProps, parseDataAttributes.parseDataAttributes(dataAttributes), {
    ref: innerRef,
    as: as,
    className: className
  }), children);
};

exports.Col = Col;
exports.Container = Container;
exports.Row = Row;
//# sourceMappingURL=Row-e4fe5862.js.map
